export enum ChannelIds {
    Android = 'AW',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    IOS = 'IW',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    WC = 'WC',
}
